import { useStoreon } from "storeon/react";
import {
  ISubscriberStore,
  ISubscriberEvents,
} from "../store/subscriberStore";

export const useSubscriberStore = () => {
  const { subscriberStore, dispatch: subscriberDispatch } = useStoreon<
    ISubscriberStore,
    ISubscriberEvents
  >("subscriberStore");

  return { subscriberStore, subscriberDispatch };
};
